import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const TextareaContainer = styled.div`
  margin-bottom: 1rem;

  h4 {
    color: ${(props) => props.color};
    font-weight: 700;
    text-transform: uppercase;
  }

  textarea {
    width: 100%;
    padding: 1rem;
    border-radius: 2rem;
    border: 1px solid
      ${(props) => (props.error ? "#ff7777" : props.bordercolor)};
    background-color: ${(props) => props.backgroundinput};
    color: ${(props) => props.colorinput};

    &:focus {
      border: 2px solid ${(props) => props.bordercolor};
      outline: none;
    }
  }

  p {
    margin-top: 0.5rem;
    color: #ff7777;
  }
`;

const CustomTextarea = ({ label, width, error, value, onChange, onBlur }) => {
  const { fontSizeMultiplier } = useConfigs();
  const { colorPrincipal, colorCuarto, colorSexto, backgroundDecimo } =
    useThemes();

  return (
    <TextareaContainer
      color={colorPrincipal}
      bordercolor={colorSexto}
      backgroundinput={backgroundDecimo}
      colorinput={colorCuarto}
      error={error}
      style={{ width: width }}
    >
      <h4 style={{ fontSize: 15 * fontSizeMultiplier }}>{label}</h4>
      <textarea
        style={{ fontSize: 15 * fontSizeMultiplier }}
        rows={4}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <p style={{ fontSize: 15 * fontSizeMultiplier }}>{error?.message}</p>
    </TextareaContainer>
  );
};

export default CustomTextarea;

CustomTextarea.propTypes = {
  label: PropTypes.string,
  width: PropTypes.string,
  error: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

CustomTextarea.defaultProps = {
  width: "100%",
};
